import { Suspense, lazy } from 'react';
import ReactGA from 'react-ga4';

const LandingPage = lazy(() => import('./pages/Landing/LandingPage'));

const MEASUREMENT_ID = `${window.env.MEASUREMENT_ID}`;

ReactGA.initialize(MEASUREMENT_ID);

export const App = () => {
  return (
    <>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', ${MEASUREMENT_ID}, {
              page_path: window.location.pathname,
            });
            `,
        }}
      />
      <Suspense fallback="">
        <LandingPage />
      </Suspense>
    </>
  );
};
